import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { EntityLink } from "~/components/entity-link";

export const StyledEntityLink = styled(EntityLink)`
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;
  white-space: nowrap;
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
`;
